import createArray from '../utils/createArray';

class SimulationLogic {
  constructor(pointDimensions, crystalColor) {
    this.pointDimensions = pointDimensions;
    this.crystalColor = crystalColor;

    this.centerPoint = { x: Math.round(this.pointDimensions.x / 2), y: Math.round(this.pointDimensions.y / 2) };
    this.pointMatrix = emptyMatrix(this.pointDimensions.y, this.pointDimensions.x);
    this._putCrystalOnPoint(this.centerPoint);

    this.entryPointArray = createEntryPointArray(this.pointDimensions);
    this.looseShard = null;
  }

  nextStep() {
    if (this.looseShard) {
      this._clearPoint(this.looseShard);
      this.looseShard = computeShardMove(this.looseShard, this.travelAngle);

      if (pointWithinBounds(this.looseShard, this.pointDimensions)) {
        this._putCrystalOnPoint(this.looseShard);
      } else {
        this.looseShard = null;
      }

    } else {
      this.looseShard = this._randomEntryPoint();
      this.travelAngle = computeAngleForPoints(this.centerPoint, this.looseShard);
      this._putCrystalOnPoint(this.looseShard);
    }

    if (this.looseShard && this._hasCrystalInNeighborhood(this.looseShard)) {
      this.looseShard = null;
    }
  }

  // =========================================================================
  // Helper methods
  // =========================================================================

  _randomEntryPoint() {
    return this.entryPointArray[Math.floor(Math.random() * this.entryPointArray.length)];
  }

  _putCrystalOnPoint(point) {
    this.pointMatrix[point.y][point.x] = this.crystalColor;
  }

  _clearPoint(point) {
    this.pointMatrix[point.y][point.x] = null;
  }

  _hasCrystalInNeighborhood(point) {
    let neighborhoodVectors = [
      { x: -1, y: 0 },
      { x: -1, y: 1 },
      { x: 0, y: 1 },
      { x: 1, y: 1 },
      { x: 1, y: 0 },
      { x: 1, y: -1 },
      { x: 0, y: -1 },
      { x: -1, y: -1 }
    ];

    for (let i = 0; i < neighborhoodVectors.length; i++) {
      let x = point.x + neighborhoodVectors[i].x;
      let y = point.y + neighborhoodVectors[i].y;

      if (x >= 0 && x < this.pointDimensions.x && y >= 0 && y < this.pointDimensions.y && this.pointMatrix[y][x]) {
        return true;
      }
    }

    return false;
  }
}


function pointWithinBounds(point, bounds) {
  return (point.x >= 0 && point.x < bounds.x && point.y >= 0 && point.y < bounds.y);
}

function computeShardMove(shardPoint, travelAngle) {
  let angleRandomFactor = 2 * (Math.random() - 0.5) * (Math.PI / 2);
  let angle = travelAngle + angleRandomFactor;
  let relativeSector = angleToRelativeSector(angle);

  return { x: shardPoint.x + relativeSector.x, y: shardPoint.y + relativeSector.y };
}

function createEntryPointArray(pointDimensions) {
  let array = [];

  for (let i = 0; i < pointDimensions.x; i++) {
    array.push({ x: i, y: 0 });
    array.push({ x: i, y: pointDimensions.y - 1 });
  }

  for (let i = 1; i < pointDimensions.y - 1; i++) {
    array.push({ x: 0, y: i });
    array.push({ x: pointDimensions.x - 1, y: i });
  }

  return array;
}

function computeAngleForPoints(point1, point2) {
  return normalizeAngle(Math.atan2(point1.y - point2.y, point1.x - point2.x));
}

function normalizeAngle(angle) {
  if (angle > Math.PI) {
    angle -= 2 * Math.PI;
  }
  if (angle < -Math.PI) {
    angle += 2 * Math.PI;
  }

  return angle;
}

function angleToRelativeSector(angle) {
  let sectorAngleWidth = Math.PI / 4;

  if (angle > sectorAngleWidth * 3.5) {
    return { x: -1, y: 0 };
  } else if (angle > sectorAngleWidth * 2.5) {
    return { x: -1, y: +1 };
  } else if (angle > sectorAngleWidth * 1.5) {
    return { x: 0, y: +1 };
  } else if (angle > sectorAngleWidth * 0.5) {
    return { x: +1, y: +1 };
  } else if (angle > sectorAngleWidth * -0.5) {
    return { x: +1, y: 0 };
  } else if (angle > sectorAngleWidth * -1.5) {
    return { x: +1, y: -1 };
  } else if (angle > sectorAngleWidth * -2.5) {
    return { x: 0, y: -1 };
  } else if (angle > sectorAngleWidth * -3.5) {
    return { x: -1, y: -1 };
  } else {
    return { x: -1, y: 0 };
  }
}

function emptyMatrix(rows, columns) {
  return createArray(rows, null).map(() => {
    return createArray(columns, null);
  });
}

export default SimulationLogic;



// WEBPACK FOOTER //
// ./src/simulation/SimulationLogic.js